import apiClient from '@/lib/api/apiClient'
import type { PolicyDeclarationFileRow } from '../types/api'
import { throwServiceError } from './serviceHelpers'

/** Download application file — GET /serve-file/APPLICATION/:applicantId/:fileType/:applicationId. */
export async function downloadDetailsFile(
  applicantId: string | number,
  applicationId: string | number,
  fileType: string,
): Promise<Blob> {
  try {
    const module = 'APPLICATION'
    const url = `/serve-file/${module}/${applicantId}/${fileType}/${applicationId}`
    const response = await apiClient.get(url, { responseType: 'blob' })
    return response.data
  } catch (error) {
    throwServiceError(error, 'Failed to download file.')
  }
}

/** Clear applicant signature. */
export async function clearSignature(applicantId: string | number): Promise<void> {
  try {
    await apiClient.get(`/api/clear_signature/${applicantId}`)
  } catch (error) {
    throwServiceError(error, 'Failed to clear signature.')
  }
}

/** Regenerate certificate (terms and conditions). */
export async function regenerateCertificate(applicantId: string | number): Promise<void> {
  try {
    await apiClient.get(`/api/regenerate_certificate/${applicantId}`)
  } catch (error) {
    throwServiceError(error, 'Failed to regenerate certificate.')
  }
}

export async function getPolicyDeclarationFiles(
  applicationId: string | number,
): Promise<PolicyDeclarationFileRow[]> {
  try {
    const response = await apiClient.get<{ files?: PolicyDeclarationFileRow[] }>(
      `/policy-declaration-files/${applicationId}`,
    )
    const files = response.data?.files
    return Array.isArray(files) ? files : []
  } catch (error) {
    throwServiceError(error, 'Failed to load policy declaration files.')
  }
}
